module.exports = __webpack_public_path__ + "img/penfold_text.d0234b43.png";